import {createAction} from "redux-act";
import {DirectionType, LeaderboardsType} from "modules/enums";

export interface IFetchLeaderboard {
	page: number;
	limit: number;
	order?: string;
	direction?: DirectionType;
	search?: string;
	haveToClear?: boolean;
	isPrevLeaderboard?: boolean;
}

export interface IFetchDailyLeaderboard extends IFetchLeaderboard {
	contestId: number;
}

export interface ILeaderboardResponse {
	ranks: IRankUser[];
	user: (IRankUser & {nextPage: number | null}) | null;
	nextPage: boolean;
	allParticipantsCount: number;
	updatedAt: string;
}

export interface IRankUser {
	userId: number;
	username: string;
	points: number;
	rank: number;
}

export const fetchYesterdayLeaderboard = createAction<IFetchLeaderboard>();
export const fetchYesterdayLeaderboardFailed = createAction();

export const fetchDailyLeaderboard = createAction<IFetchLeaderboard>();
export const fetchDailyLeaderboardFailed = createAction();

export const fetchAllTimeLeaderboard = createAction<IFetchLeaderboard>();
export const fetchAllTimeLeaderboardFailed = createAction();

export const fetchLeaderboardSuccess = createAction<ILeaderboardResponse>();

export const fetchAllLeaderboardsData = createAction<IFetchLeaderboard>();
export const fetchAllLeaderboardsDataSuccess = createAction();
export const fetchAllLeaderboardsDataFailed = createAction();

export const setSelectedLeaderboard = createAction<{value: LeaderboardsType}>();
export const clearFetchedPagesLeaderboards = createAction();
export const clearLeaderboard = createAction();

export interface IUserProfilePayload {
	userId: number;
}

export interface IUserProfileResponse {
	careerStats: ICareerStats;
	categoryLeaderboard: ICategoryLeaderboard[];
}

export interface ICareerStats {
	gamesPlayed: number;
	avgScore: number;
	highScore: number;
	totalPoints: number;
}
export interface ICategoryLeaderboard {
	category: string;
	highScore: number;
	rank: number;
}

export const fetchLeaderProfile = createAction<IUserProfilePayload>();
export const fetchLeaderProfileSuccess = createAction<IUserProfileResponse>();
export const fetchLeaderProfileFailed = createAction();
